import { render, staticRenderFns } from "./EzProductsUpdateModal.vue?vue&type=template&id=8b0ce1d8&scoped=true&"
import script from "./EzProductsUpdateModal.vue?vue&type=script&lang=js&"
export * from "./EzProductsUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./EzProductsUpdateModal.vue?vue&type=style&index=0&id=8b0ce1d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0ce1d8",
  null
  
)

export default component.exports